var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"content"},[_c('DayPilotScheduler',{ref:"scheduler",attrs:{"id":"dpS","config":_vm.config}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }